"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var model_1 = require("../shared/model");
var shared_1 = require("@formily/shared");
exports.VirtualField = model_1.createModel((_a = (function () {
        function FormStateFactory(props) {
            this.state = {
                name: '',
                path: '',
                initialized: false,
                visible: true,
                display: true,
                mounted: false,
                unmounted: false,
                props: {}
            };
            this.nodePath = shared_1.FormPath.getPath(props.nodePath);
            this.dataPath = shared_1.FormPath.getPath(props.dataPath);
            this.state.path = this.nodePath.entire;
            this.state.name = this.dataPath.entire;
        }
        FormStateFactory.prototype.produce = function (draft, dirtys) {
            if (draft.mounted === true && dirtys.mounted) {
                draft.unmounted = false;
            }
            if (!shared_1.isValid(draft.props)) {
                draft.props = {};
            }
            if (draft.unmounted === true && dirtys.unmounted) {
                draft.mounted = false;
            }
        };
        return FormStateFactory;
    }()),
    _a.displayName = 'VirtualFieldState',
    _a));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/core/lib/models/virtual-field.js
// module id = 5760
// module chunks = 0